import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import t from 'ember-intl/helpers/t';
import type MedicationRequest from 'parog-web/models/prescriptions/medication-request';

export default <template>
  {{@prescription.medication.description}}

  {{#if @prescription.dosage}}
    :
    {{#if @prescription.dosage.doseQuantity}}
      {{t
        (concat
          'prescriptions.doseQuantities.' @prescription.dosage.doseQuantity
        )
      }}
    {{/if}}
    {{#if @prescription.dosage.timing}}
      {{t
        (concat 'prescriptions.timings.' @prescription.dosage.timing.computedId)
      }}
    {{/if}}
  {{/if}}

  {{#if @prescription.comment}}
    <br />
    <span class='semeia faded-text-color'>
      {{@prescription.comment}}
    </span>
  {{/if}}
</template> satisfies TemplateOnlyComponent<{
  Args: { prescription: MedicationRequest };
}>;
